export const getTenantFinancialsQuery = (tenantId, startDate="", endDate="") => {
    const query = `
        query{
            tenantFinancials(
                tenantId:"${tenantId}",
                startDate: ${ !startDate? JSON.stringify("") : JSON.stringify(startDate.format("YYYY-MM-DD"))}, 
                endDate: ${ !endDate? JSON.stringify("") : JSON.stringify(endDate.format("YYYY-MM-DD"))}
            ){
                id
                date
                itemType
                amount
                description
                moneyPaid
                moneyDue
                endOfDayBalance    
                message
            }
        }
    `;
    return query;
}

export const getTenantPaymentQuery = (paymentId) => {
    const query = `
        query{
            tenantPayment(
                paymentId:"${paymentId}"
            ){
                id
                amount
                paymentType
                description
                paymentDate
                status
                bankTransactionId
                upload{
                    id
                    file
                    name
                }
            }
        }
    `;
    return query;
}